/*
 * Copyright (c) 2026. BrightNight. All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */
import { Slide, type ToastContainerProps } from 'react-toastify';
import {
  SHELL_ACTION_GROUP_HEIGHT,
  SHELL_ACTIONS_GAP,
  SHELL_ACTIONS_RIGHT,
  SHELL_ACTIONS_TOP,
} from './desktop/shellLayout';
import { notificationContainerId } from './notifications/showNotificationToast';
import { ALERT_TOAST_CONTAINER_ID } from './paToast';

/** App feedback (paToast): bottom-left, one neutral card per alert (toast.css). */
export const alertToastContainerProps: ToastContainerProps = {
  containerId: ALERT_TOAST_CONTAINER_ID,
  className: 'alert-toast-container',
  toastClassName: 'alert-toast',
  position: 'bottom-left',
  transition: Slide,
  limit: 3,
  hideProgressBar: true,
  closeOnClick: true,
};

/** Notifications: top-right under the menu cluster, collapsed stack that expands on hover. */
export const notificationToastContainerProps: ToastContainerProps = {
  containerId: notificationContainerId,
  className: 'notification-toast-container',
  // Aligned to the top-right action pill's right edge, just below it.
  style: {
    top: SHELL_ACTIONS_TOP + SHELL_ACTION_GROUP_HEIGHT + SHELL_ACTIONS_GAP,
    right: SHELL_ACTIONS_RIGHT,
  },
  position: 'top-right',
  transition: Slide,
  // MAX_NOTIFICATION_TOASTS plus the "+N more" pill
  limit: 4,
  stacked: true,
  closeOnClick: true,
};
